/** 全局常量集中定义（避免魔法字符串散落在各模块） */
export const ADMIN_TOKEN_KEY = 'loan_admin_token'
export const ADMIN_USER_KEY = 'loan_admin_username'
export const DEFAULT_APP_TITLE =
  import.meta.env.VITE_APP_TITLE || '贷款管理后台'

export const apiBaseURL = (): string =>
  import.meta.env.VITE_API_PREFIX?.trim() || ''
